import { Component, Input, inject } from '@angular/core';
import { Colors, IconName } from '@evonik/evo';
import { ConfigService } from '@evonik/ng-core';

@Component({
    selector: 'app-authorization-error',
    templateUrl: './authorization-error.component.html',
    styleUrls: ['./authorization-error.component.scss'],
    standalone: false
})
export class AuthorizationErrorComponent {
    private configService = inject(ConfigService);

    colors = Colors;
    iconNames = IconName;

    logout(): void {
        window.location.href = `${this.configService.getConfig().get('apiBaseUrl')}/saml/logout`;
    }

    openMyAmino() {
        window.location.href = 'https://myamino.evonik.com';
    }
}
